//@flow
import FunctionStore from '../Base/functionStoreClass';
import { updateState } from '../Base/storeUtils';
import { toImmutable, toJSCached } from '../../Utils/immutable';
import Constants from '../../constants';
import CookiesData from '../../Utils/cookies-data';
import CustomerStore from '../Customer/customer';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export default class NotificationsStore extends FunctionStore {

  getNotification(name:string):?Object {
    const state = this.getState();
    if (state.getIn(['notification', 'name']) !== name) return null;
    return toJSCached(state.getIn(['notification', 'value']));
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {

    // allow for manually adding a notification either from UI activity or a test
    onSuccess(Constants.ADD_NOTIFICATION, updateState(_addNotification));

    onSuccess(Constants.GET_CUSTOMER_SUCCESS, updateState(_addStoreCreditNotification), [ CustomerStore ]);

    // action for clearing out a notification after it has been displayed
    onSuccess(Constants.CLEAR_NOTIFICATION, updateState(_clearNotification));

    // watch for quote item events for cart notifications
    onSuccess(Constants.ADD_QUOTE_ITEM, updateState(_addOrUpdateQuoteItem));
    onSuccess(Constants.UPDATE_QUOTE_ITEM_QTY, updateState(_addOrUpdateQuoteItem));
    onSuccess(Constants.DELETE_QUOTE_ITEM, updateState(_deleteQuoteItem));
  }
}

function _addNotification(state:StoreState, { name, value }:{ name:string, value:Object }) {
  state.set('notification', toImmutable({ name, value }));
}

function _addStoreCreditNotification(state:StoreState) {
  const customer = CustomerStore.getCustomer();
  const storeCredit = customer && customer.getStoreCredit();
  if (!CookiesData.getStoreCredit() && storeCredit >= 5) {
    _addNotification(state, { name: Constants.STORE_CREDIT_NOTIFICATION, value: { storeCredit } });
    CookiesData.setStoreCredit();
  }
}

function _clearNotification(state:StoreState, { name }:{ name:string }) {
  if (state.getIn(['notification', 'name']) === name) state.delete('notification');
}

function _addOrUpdateQuoteItem(state:StoreState, data:Object) {
  if (!data) return;
  const cartNotification = Object.assign({}, data, { qty: data.qty || 1 });
  _addNotification(state, { name: Constants.CART_NOTIFICATION, value: cartNotification });
}

function _deleteQuoteItem(state:StoreState, { sku, quoteId }:{ sku:string, quoteId:string }) {
  _addNotification(state, { name: Constants.CART_NOTIFICATION, value: { sku, qty: 0, quoteId }});
}
